import { Row, Col } from "antd"
import { NavLink } from 'react-router-dom';
import { useContext, useEffect } from "react";
import DiffuseReflection2 from '../assets/MenuCalculators/Diffuse_Reflection_P.webp'
import PointnadExtendedP from '../assets/MenuCalculators/Laser P.png'
import FiberOpticP from '../assets/MenuCalculators/Fibre_Optics_P.webp'
import LookupTableP from '../assets/MenuCalculators/LookUp_Table_P.webp'
import './plan.css'
import { EnvironmentContext } from "../routes/EnvironmentContext";
import { useTranslation } from "react-i18next";

export function CalculatorNavigationHomePage({ isFree }) {
    // if (!sethandleClick) throw new Error('setHandleClick property was not set for CalculatorNavigationHomePage!')
    const { selectedStandard } = useContext(EnvironmentContext)
    const { t } = useTranslation()
    let endURL = `${selectedStandard}/`
    if (!isFree) {
        // console.log(`It's not free at all.`)
    } else {
        // console.log(`It's free after all!`)
        endURL += "free/"
    }

    useEffect(() => {
        const menuImages = [
            "/images/Laser_P2.webp",
            "/images/Fiber_Optics_P2.webp",
            "/images/Diffuse_Reflection_P2.webp",
            "/images/Lookup_Table_P2.webp",
        ];

        menuImages.forEach((src) => {
            const link = document.createElement("link");
            link.rel = "preload";
            link.as = "image";
            link.href = src;
            document.head.appendChild(link);
        });
    }, []);

    return (
        <>
            <Row justify={'center'} style={{ margin: '3% 0 3% 0' }} gutter={[16, 16]}>
                <Col align='middle' xs={24} sm={24} md={12} lg={5} >
                    <div className="card" style={{ border: "1px solid black" }}>
                        <NavLink to={`/mpe-ael-calc/${endURL}`} style={{ textDecoration: "none", display: "flex", justifyContent: 'center' }}>
                            <img src={"/images/Laser_P.webp"} alt=" To Point and Extended Calculator" ></img>
                            <div className="intro">
                                <h1>{isFree && ('Free ')}{t('10038')}</h1>
                                <p>{t('10042')}
                                {/* The point source has a laser emission from a single point and has a miniscule diameter
                                    compared with the viewing distance while an extended source is the opposite with
                                    laser emitted from various points and a relatively large diameter. */}
                                </p>
                            </div>
                        </NavLink>
                    </div>
                </Col>
                <Col align='middle' xs={24} sm={24} md={12} lg={5} >
                    <div className="card" style={{ border: "1px solid black" }}>
                        <NavLink to={`/fiber-optic/${endURL}`} style={{ textDecoration: "none", display: "flex", justifyContent: 'center' }}>
                            <img src={ "/images/Fibre_Optics_P.webp"} alt="To Fiber Optic Calculator"></img>
                            <div className="intro">
                                <h1>{isFree && ('Free ')}{t('10039')}</h1>
                                <p>{t('10043')}
                                </p>
                            </div>
                        </NavLink>
                    </div>
                </Col>
                <Col align='middle' xs={24} sm={24} md={12} lg={5} >
                    <div className="card" style={{ border: "1px solid black" }}>
                        <NavLink to={`/diffuse-reflective/${endURL}`} style={{ textDecoration: "none", display: "flex", justifyContent: 'center' }}>
                            <img src={"/images/Diffuse_Reflection_P.webp"} alt="To Diffuse Reflective Calculator"></img>
                            <div className="intro">
                                <h1>{isFree && ('Free ')}{t('10040')}</h1>
                                <p>{t('10044')}
                                </p>
                            </div>
                        </NavLink>
                    </div>
                </Col>
                <Col align='middle' xs={24} sm={24} md={12} lg={5} >
                    <div className="card" style={{ border: "1px solid black" }}>
                        <NavLink to={`/lookup-table/${endURL}`} style={{ textDecoration: "none", display: "flex", justifyContent: 'center' }}>
                            <img src={  "/images/LookUp_Table_P.webp"} alt="To Lookup Table Calculator"></img>
                            <div className="intro">
                                <h1>{isFree && ('Free ')}{t('10041')}</h1>
                                <p>{t('10045')}
                                </p>
                            </div>
                        </NavLink>
                    </div>
                </Col>
            </Row>
        </>)

}
